import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
// import { getDocument, GlobalWorkerOptions, PDFDocumentProxy, PDFRenderParams, version, ViewportParameters } from 'pdfjs-dist';
import { getDocument, GlobalWorkerOptions, PDFDocumentProxy, version } from 'pdfjs-dist';

@Injectable({
  providedIn: 'root',
})
export class MyPdfService {
  private document: Document;
  constructor(@Inject(DOCUMENT) document) {
    this.document = document;
    const pdfWorkerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${version}/pdf.worker.min.js`;
    GlobalWorkerOptions.workerSrc = pdfWorkerSrc;
  }

  public pdf: PDFDocumentProxy;
  // My use case demonstrating strongly typed usage.
  public async loadPdf(pdfFile: File) {
    if (this.pdf != null) this.pdf.destroy();

    const arrayBuffer = await new Response(pdfFile).arrayBuffer();
    this.pdf = await getDocument(arrayBuffer).promise;
    //const page = await this.pdf.getPage(1);
  }
  public async pdfToImagesDataURLAsync(): Promise<string> {
    const canvas = this.document.createElement('canvas'),
      ctx = canvas.getContext('2d') as CanvasRenderingContext2D;

    const page = await this.pdf.getPage(1);
    const viewPortParams: any = { scale: 2 };
    const viewport = page.getViewport(viewPortParams);

    canvas.height = viewport.height;
    canvas.width = viewport.width;

    const renderContext: any = {
      canvasContext: ctx,
      viewport: viewport,
    };

    await page.render(renderContext).promise;
    const res = canvas.toDataURL();
    // if (pdf != null) pdf.destroy();
    return res;
  }
  public async pdfToAllImageDataURLAsync(pdfFile: File): Promise<any> {
    const arrayBuffer = await new Response(pdfFile).arrayBuffer();
    const data = arrayBuffer;
    const pdf: PDFDocumentProxy = await getDocument(data).promise;
    let allpages = [];

    const canvas = this.document.createElement('canvas');
    const ctx = canvas.getContext('2d') as CanvasRenderingContext2D;

    for (let i = 1; i < pdf.numPages + 1; i++) {
      const page = await pdf.getPage(i);
      const viewPortParams: any = { scale: 2 };
      const viewport = page.getViewport(viewPortParams);

      canvas.height = viewport.height;
      canvas.width = viewport.width;

      const renderContext: any = {
        canvasContext: ctx,
        viewport: viewport,
      };

      await page.render(renderContext).promise;
      const res = canvas.toDataURL();

      allpages.push(res);
    }

    if (pdf != null) pdf.destroy();
    return allpages;
  }
  public async _pdfToImageDataURLAsync(pdfFile: File): Promise<string> {
    const arrayBuffer = await new Response(pdfFile).arrayBuffer();
    const canvas = this.document.createElement('canvas'),
      ctx = canvas.getContext('2d') as CanvasRenderingContext2D,
      data = arrayBuffer;

    const pdf: PDFDocumentProxy = await getDocument(data).promise;
    const page = await pdf.getPage(1);

    const viewPortParams: any = { scale: 2 };
    const viewport = page.getViewport(viewPortParams);

    canvas.height = viewport.height;
    canvas.width = viewport.width;

    const renderContext: any = {
      canvasContext: ctx,
      viewport: viewport,
    };

    await page.render(renderContext).promise;
    const res = canvas.toDataURL();
    if (pdf != null) pdf.destroy();
    return res;
  }
}
